import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Affiliations = ({ setIsOpen, editor, setShowFMatter }) => {
  const [affiliationData, setAffiliationData] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (!editor) return;
    const affs = editor.dom.select("aff");

    const parsed = affs.map((affElement, index) => {
      const children = Array.from(affElement.children);
      return {
        index,
        tag: affElement.tagName,
        children: children.map((child) => ({
          tag: child.tagName.toLowerCase(),
          text: child.textContent,
          attributes: Object.fromEntries(
            [...child.attributes].map((attr) => [attr.name, attr.value])
          ),
        })),
      };
    });

    setAffiliationData(parsed);
  }, [editor]);

  const relabelAffs = (affArray) => {
    return affArray.map((aff, i) => {
      const updatedChildren = aff.children.map((child) => {
        if (child.tag.toLowerCase() === "label") {
          return {
            ...child,
            text: ` ${i + 1} `,
          };
        }
        return child;
      });

      return {
        ...aff,
        children: updatedChildren,
      };
    });
  };

  const handleChange = (rowIndex, tag, value) => {
    setAffiliationData((prev) =>
      prev.map((item, i) => {
        if (i !== rowIndex) return item;
        const children = [...item.children];
        const childIndex = children.findIndex((c) => c.tag === tag);
        if (childIndex > -1) {
          children[childIndex].text = value;
        } else {
          children.push({ tag, text: value, attributes: {} });
        }
        return { ...item, children };
      })
    );
  };
  const handleCancel = () => {
    setOpen(null);
    setIsOpen(null);
    setShowFMatter({
      authorgrouping: false,
      affiliation: false,
      keywords: false,
    });
  };

  const handleAddRow = (index) => {
    const newAff = {
      index: affiliationData.length,
      tag: "AFF",
      children: [
        { tag: "label", text: index + 2, attributes: {} },
        { tag: "institution", text: "", attributes: {} },
        { tag: "addr-line", text: "", attributes: {} },
        { tag: "country", text: "", attributes: {} },
      ],
    };

    const updated = [...affiliationData];
    updated.splice(index + 1, 0, newAff);
    const updatedData = relabelAffs(updated);
    setAffiliationData(updatedData);
    setOpen(index + 1);
  };

  const handleRemoveRow = (i) => {
    const updated = [...affiliationData];
    const newUpdated = updated.filter((_, idx) => idx !== i);
    const updatedData = relabelAffs(newUpdated);
    setAffiliationData(updatedData);
  };

  // Submit changes back to the editor DOM
  // const handleSubmit = () => {
  //   if (!editor) return;

  //   const contribGroup = editor.dom.select("contrib-group")[0];
  //   if (!contribGroup) return;

  //   const existingAffs = editor.dom.select("contrib-group > aff");

  //   affiliationData.forEach((data, index) => {
  //     let affNode = existingAffs[index];

  //     // If aff already exists, update it
  //     if (affNode) {
  //       // console.log(affNode.firstChild);

  //       while (affNode.firstChild) affNode.removeChild(affNode.firstChild);

  //       data.children.forEach((child) => {
  //         const childNode = editor.dom.create(
  //           child.tag,
  //           child.attributes,
  //           child.text
  //         );
  //         affNode.appendChild(childNode);
  //       });
  //     } else {
  //       // Create new aff
  //       const newAff = editor.dom.create("aff");

  //       data.children.forEach((child) => {
  //         const childNode = editor.dom.create(
  //           child.tag,
  //           child.attributes,
  //           child.text
  //         );
  //         newAff.appendChild(childNode);
  //       });

  //       // Insert after previous aff if present, else append
  //       const prevAff = existingAffs[index - 1];
  //       if (prevAff && prevAff.nextSibling) {
  //         contribGroup.insertBefore(newAff, prevAff.nextSibling);
  //       } else {
  //         contribGroup.appendChild(newAff);
  //       }
  //     }
  //   });

  //   // Remove extra affs if any
  //   const allAffs = editor.dom.select("contrib-group > aff");
  //   for (let i = affiliationData.length; i < allAffs.length; i++) {
  //     allAffs[i]?.remove();
  //   }

  //   handleCancel();
  // };

  const handleAffliationChange = () => {
    const contribGroup = editor.dom.select("contrib-group")[0];
    let refCits = contribGroup.querySelectorAll("xref");

    refCits.forEach((cit) => {
      const oldRid = editor.dom.getAttrib(cit, "rid")?.trim();
      const matchingAff = editor.dom.select(`aff[tid="${oldRid}"]`)[0];
      //  const removedAff = editor.dom.select(`aff[id="${oldRid}"]`)[0];
      //  const removeAff = editor.dom.select(`aff[tid="${oldRid}"]`)[0];
      const removedAffArray = editor.dom.select(`aff[id="${oldRid}"]`);
      const removeAffArray = editor.dom.select(`aff[tid="${oldRid}"]`);

      let newId = oldRid;

      if (matchingAff) {
        newId = editor.dom.getAttrib(matchingAff, "id");

        const newNum = newId.split("-")[1];
        // Extract number from ref-id
        editor.dom.setAttrib(cit, "rid", newId);
        editor.dom.setAttrib(cit, "href", `#${newId}`);
        editor.dom.setAttrib(cit, "data-mce-href", `#${newId}`);
        editor.dom.setHTML(cit, `${newNum}`); // Display the number in xref
      }

      if (removedAffArray.length === 0 && removeAffArray.length === 0) {
        editor.dom.remove(cit);
      }
    });

    const affs = contribGroup.querySelectorAll("aff");

    affs.forEach((aff) => {
      if (aff.hasAttribute("tid")) {
        aff.removeAttribute("tid");
      }
    });
  };

  const handleSubmit = () => {
    if (!editor) return;
  editor.undoManager.transact(() => {
    const contribGroup = editor.dom.select("contrib-group")[0];
    if (!contribGroup) return;

    const existingAffs = contribGroup.querySelectorAll("aff");

    const validAffIds = affiliationData.map(
      (data) => `aff-${data.children[0].text.trim()}`
    );

    existingAffs.forEach((aff) => {
      const affId = editor.dom.getAttrib(aff, "id");
      if (!validAffIds.includes(affId)) {
        aff.parentNode.removeChild(aff);
      }
    });
    affiliationData.forEach((data, index) => {
      const affOldId = `aff-${data.index + 1}`;
      const affNewId = `aff-${data.children[0].text.trim()}`;
      const affNode = editor.dom.select(`#${affNewId}`)[0];
      console.log(affNode, "affnode");

      if (affNode) {
        const existingButton = affNode.querySelector(
          'button[data-btn-type="affiliationedit"]'
        );

        Array.from(affNode.children).forEach((child) => {
          if (child.tagName.toLowerCase() !== "button") {
            affNode.removeChild(child);
          }
        });

        data.children.forEach((child) => {
          const childNode = editor.dom.create(
            child.tag,
            child.attributes,
            child.text
          );
          affNode.insertBefore(childNode, existingButton || null);
        });

        // Re-append button if it existed and got detached
        if (existingButton && !affNode.contains(existingButton)) {
          affNode.appendChild(existingButton);
        }

        affNode.setAttribute("tid", affOldId);
      } else {
        // Create new aff with incremented id

        const newAffId = `aff-${
          existingAffs.length + (index - existingAffs.length) + 1
        }`;
        const newAff = editor.dom.create("aff", { id: newAffId });

        data.children.forEach((child) => {
          const childNode = editor.dom.create(
            child.tag,
            child.attributes,
            child.text
          );
          newAff.appendChild(childNode);
          newAff.setAttribute("tid", affOldId);
        });

        // Insert after last existing aff or append at end
        const lastAff = existingAffs[existingAffs.length - 1];
        if (lastAff && lastAff.nextSibling) {
          contribGroup.insertBefore(newAff, lastAff.nextSibling);
        } else {
          contribGroup.appendChild(newAff);
        }
      }
    });

    handleAffliationChange();
    toast.success("Changes Updated")
    handleCancel();
  })
  };

  const handleMoveRow = (i) => {
    const cloneData = [...affiliationData];

    if (i < cloneData.length - 1) {
      [cloneData[i], cloneData[i + 1]] = [cloneData[i + 1], cloneData[i]];

      cloneData.forEach((item, index) => {
        item.children[0].text = `${index + 1}`;
      });
      const updatedData = relabelAffs(cloneData);
      setAffiliationData(updatedData);
    }
  };
  const handleOpen = (i) => {
    if (open == i) {
      setOpen(null);
    } else {
      setOpen(i);
    }
  };

  return (
    <div className="w-full h-full">
      <div className="flex flex-col h-full justify-between">
        <div className="flex flex-col gap-4 overflow-auto w-full [&::-webkit-scrollbar]:hidden">
          {affiliationData.map((data, i) => {
            const tagMap = Object.fromEntries(
              data.children.map((child) => [child.tag, child.text])
            );

            return (
              <div key={i}>
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between">
                    <p className="text-[15px] text-primary font-semibold">
                      Affliation-{tagMap["label"]}
                    </p>
                    <div className="flex gap-2">
                      <button
                        title="Edit"
                        className="text-[20px] text-refbtnhover hover:bg-refbtnhover hover:text-white p-[2px] rounded-[3px]"
                        onClick={() => handleOpen(i)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-edit"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                          <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                          <path d="M16 5l3 3" />
                        </svg>
                      </button>
                      <button
                        title="Add"
                        className="text-nowrap text-refbtnhover hover:bg-refbtnhover hover:text-white p-[2px] rounded-[3px]"
                        onClick={() => handleAddRow(i)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-plus"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 5l0 14" />
                          <path d="M5 12l14 0" />
                        </svg>
                      </button>
                      <button
                        title="Move"
                        className="text-green hover:bg-green hover:text-white p-[2px] rounded-[3px]"
                        onClick={() => handleMoveRow(i)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-switch-vertical"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 8l4 -4l4 4" />
                          <path d="M7 4l0 9" />
                          <path d="M13 16l4 4l4 -4" />
                          <path d="M17 10l0 10" />
                        </svg>
                      </button>
                      <button
                        title="Remove"
                        className=" text-nowrap text-red hover:text-white hover:bg-red rounded-[3px] p-[2px]"
                        onClick={() => handleRemoveRow(i)}
                        disabled={affiliationData.length === 1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M4 7l16 0" />
                          <path d="M10 11l0 6" />
                          <path d="M14 11l0 6" />
                          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <p className="text-[15px] text-primary flex gap-2 break-all">
                    {tagMap["institution"]}
                    {tagMap["addr-line"]}
                    {tagMap["country"]}
                  </p>
                </div>

                {open === i && (
                  <div
                    key={i}
                    className="flex mt-5 flex-col border border-grey bg-white rounded-lg w-full gap-2 text-[13px] px-2 py-3"
                  >
                    {["label", "institution", "addr-line", "country"].map(
                      (field) => (
                        <div
                          key={field}
                          className="flex w-full flex-col gap-2 "
                        >
                          <label>{field}</label>
                          <input
                            title={tagMap[field] || ""}
                            className="border-[1px] border-grey p-[4px] outline-none"
                            type="text"
                            value={tagMap[field] || ""}
                            onChange={(e) =>
                              handleChange(i, field, e.target.value)
                            }
                            disabled={field === "label"}
                          />
                        </div>
                      )
                    )}
                  </div>
                )}
                <hr className="mt-4  border-grey" />
              </div>
            );
          })}
        </div>

        <div className="ml-auto mt-5">
          <div className="flex  ml-auto gap-4 text-[15px]">
            <button
              className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
              onClick={() => handleCancel()}
            >
              {" "}
              Cancel
            </button>
            <button
              className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
              onClick={() => handleSubmit()}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Affiliations;
